// extracted by mini-css-extract-plugin
export default {"service":"Service__service___1FjbZ","selected":"Service__selected___1klZQ","image":"Service__image___1lHtT"};